import { render, staticRenderFns } from "./dataShow.vue?vue&type=template&id=e82a73f4&scoped=true&"
import script from "./dataShow.vue?vue&type=script&lang=js&"
export * from "./dataShow.vue?vue&type=script&lang=js&"
import style0 from "./dataShow.vue?vue&type=style&index=0&id=e82a73f4&prod&lang=scss&"
import style1 from "./dataShow.vue?vue&type=style&index=1&id=e82a73f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82a73f4",
  null
  
)

export default component.exports